// spendWise:
import spendWiseP1 from "./spendWise/001.webp";
import spendWiseP2 from "./spendWise/002.webp";
import spendWiseP3 from "./spendWise/003.webp";
import spendWiseP4 from "./spendWise/004.webp";

// boomEscape:
import boomEscapeP1 from "./boomEscape/001.webp";
import boomEscapeP2 from "./boomEscape/002.webp";
import boomEscapeP3 from "./boomEscape/003.webp";
import boomEscapeP4 from "./boomEscape/004.webp";

// uarQueue:
import uarQueueP1 from "./uarQueue/001.webp";
import uarQueueP2 from "./uarQueue/002.webp";
import uarQueueP3 from "./uarQueue/003.webp";
import uarQueueP4 from "./uarQueue/004.webp";

// altrbot:

import altrbotP1 from "./altrbot/001.webp";
import altrbotP2 from "./altrbot/002.webp";
import altrbotP3 from "./altrbot/003.webp";
import altrbotP4 from "./altrbot/004.webp";

// hiddenReads:

import hiddenReadsP1 from "./hiddenReads/001.webp";
import hiddenReadsP2 from "./hiddenReads/002.webp";
import hiddenReadsP3 from "./hiddenReads/003.webp";
import hiddenReadsP4 from "./hiddenReads/004.webp";

// flockingSimulation:

import flockingSimulationP1 from "./flockingSimulation/001.webp";
import flockingSimulationP2 from "./flockingSimulation/002.webp";
import flockingSimulationP3 from "./flockingSimulation/003.webp";
import flockingSimulationP4 from "./flockingSimulation/004.webp";

export const altrbot = [
  altrbotP1,
  altrbotP2,
  altrbotP3,
  altrbotP4,
];

export const hiddenReads = [
  hiddenReadsP1,
  hiddenReadsP2,
  hiddenReadsP3,
  hiddenReadsP4,
];

export const flockingSimulation = [
  flockingSimulationP1,
  flockingSimulationP2,
  flockingSimulationP3,
  flockingSimulationP4,
];

export const spendWise = [spendWiseP1, spendWiseP2, spendWiseP3, spendWiseP4];
export const boomEscape = [
  boomEscapeP1,
  boomEscapeP2,
  boomEscapeP3,
  boomEscapeP4,
];
export const uarQueue = [uarQueueP1, uarQueueP2, uarQueueP3, uarQueueP4];
